import axios from 'api/api.config';
import { useMutation } from 'react-query';

export function useGetAdminProfile() {
  return useMutation(() => axios.get('/api/v1/admin/profile').then((res) => res.data));
}
